import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom"
import { AuthContext } from "./Auth"
import EpicMenu from './componentes/Menus/EpicMenu'

const PrivateRoute = ({ component: RouteComponent, roles = [], ...rest }) => {
  const { currentUser } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={routeProps =>
        !!currentUser ?
          roles.includes(currentUser.rol) || currentUser.rol === 'admin' || roles.includes('todos') || currentUser.email === "admin@admin.com"
            ?
            <RouteComponent {...routeProps} />
            :
            <Redirect to={"/Perfil"} />
          : (
            <Redirect to={"/login"} />
          )
      }
    />
  );
};


export default PrivateRoute;